import * as React from 'react'
import { Helmet } from 'react-helmet'

import NewBrandDashboard from '../BrandDashboard'

import BrandOrdersNew from './BrandTeamNew/brand-orders-new'

interface BrandDashboardOrdersNewProps {
  match?: { params: { id: string } }
  searchToken?: string
}

const BrandDashboardOrdersNew: React.FC<BrandDashboardOrdersNewProps> = ({
  match,
  searchToken,
}) => {
  const brandId = match && match.params.id
  const bodyClass = document.body.className.replace(/\s+/g, '_').toLowerCase()

  return (
    <>
      <Helmet>
        <title>Dashboard - 90 Seconds</title>
      </Helmet>
      <NewBrandDashboard
        brandId={brandId}
        activeButton={0}
        searchToken={searchToken}
        children={<BrandOrdersNew brandId={brandId} key={bodyClass} />}
        isSubHeaderHidden={true}
      />
    </>
  )
}

export default BrandDashboardOrdersNew



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardOrdersNew/BrandDashboardOrdersNew.tsx